<template>
    <section>
        <div class="row">
            <div class="col">
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb">
                        <li class="breadcrumb-item h3 font-weight-bold mb-0">
                            <router-link v-bind:to="{ name: 'forum/index' }">
                                Forum
                            </router-link>
                        </li>
                        <li class="breadcrumb-item font-weight-medium">
                            <router-link v-bind:to="{ name: 'forum/subject', params: {id: gradeSubject.gradeID} }">
                                {{ gradeSubject.grade.name }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active font-weight-medium" aria-current="page">
                            {{ gradeSubject.subject.name }}
                        </li>
                    </ul>
                </nav>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <div class="card shadow-sm mb-4 border-0">
                    <div class="card-header background-primary">
                        <div class="row justify-content-end">
                            <div class="col">
                                <span class="h4 font-weight-medium text-white mb-0 text-uppercase">
                                    {{ gradeSubject.subject.name }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="card-body py-0">
                        <div class="row">
                            <div class="col-12 col-sm-6 border-bottom py-3" v-for="category in categories">
                                <router-link v-bind:to="{ name: 'forum/thread/index', params: {id: category.id} }" class="font-weight-bold h4 mb-1">{{ category.title }}</router-link>
                                <div class="row text-muted">
                                    <div class="col" v-html="category.description"></div>
                                </div>
                                <div class="row text-muted">
                                    <div class="col-auto">
                                        Jumlah Thread: {{ category.totalThreads }}
                                    </div>
                                    <div class="col-auto">
                                        Solved Thread: {{ category.solvedThreads }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        name: "ForumCategory",
        computed: mapState([
            'term'
        ]),
        watch: {
            term() {
                this.fetchData();
            }
        },
        data() {
            return {
                gradeSubject: {grade: {}, subject: {}},
                categories: []
            };
        },
        methods: {
            fetchData() {
                this.axios.get(process.env.API_URL + '/forum-subcategory', {params: {gradeSubjectID: this.gradeSubject.id, termID: this.term.id}}).then(response => {
                    this.categories = response.data.data;
                });
            }
        },
        created() {
            this.axios.get(process.env.API_URL + '/grade-subject/' + this.$route.params.id).then(response => {
                this.gradeSubject = response.data.data;
                
                this.fetchData();

                document.title = 'Forum - ' + this.gradeSubject.grade.name + ' ' + this.gradeSubject.subject.name + ' | ' + process.env.APP_NAME;
            });
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/forum/Category.vue